import { IEnvironment } from './environment';

export const environmentDefault: IEnvironment = {
    alternativeLogo: false,
    // TODO: apiUrl is deprecated. Use apiBaseUrl instead.
    apiUrl: 'https://api.cupofsugar.io/api/v0',
    apiBaseUrl: 'https://api.cupofsugar.io',
    apiUrlV1: 'https://api.cupofsugar.io/api/v1',
    blockchain: {
        coinName: 'Erg',
    },
    defaultLocale: 'en',
    environments: [
        {
            name: 'Mainnet',
            url: 'https://api.cupofsugar.io',
        },
    ],
    isLoggerEnabled: true,
};
